/**
 * PageState — shared centered message block for full-page states (error,
 * empty/"being prepared"). Kept in its own module so HoroscopePage and
 * HoroscopeFeed share one source of truth without importing from each other.
 */
import { ReactNode } from 'react'

export function PageState({ children }: { children: ReactNode }) {
  return <div className="py-20 text-center text-bodyMedium text-textSecondary">{children}</div>
}

export default PageState
